/* TelaPersonalizzata · Configuratore stampe foto v8
 *
 * Sostituisce l'interfaccia di configuratore-foto.js quando l'opzione della sezione è accesa.
 * Resta identico al precedente in tutto ciò che vede il laboratorio:
 *   - prodotto stampa-foto-configuratore, varianti Formato / Carta / Fascia quantità;
 *   - fascia calcolata sul totale delle copie dello stesso formato (le due carte insieme);
 *   - file JPG ritagliato al formato, al massimo 200 dpi (impostabile), caricato su foto.telapersonalizzata.com
 *     con storage.php + PUT + upload.php, stessi parametri;
 *   - righe del carrello per variante, 30 copie per riga, proprietà _lotto_foto, _parte, _totale_formato,
 *     _formato, _materiale, _fascia, _photo1…_photo30 (una voce per copia).
 *     Le copie per riga si possono alzare dall'editor («Foto per riga del carrello», fino a 1000):
 *     allora le proprietà vanno fino a _photoN con N = copie della riga.
 * Se si torna dal carrello o si riprova dopo un errore, le righe già aggiunte da questa pagina
 * (riconosciute dal loro _lotto_foto) vengono tolte e rimesse tutte insieme: niente doppioni.
 */
(function () {
  'use strict';

  var root = document.getElementById('tpf');
  if (!root) return;

  /* ------------------------------------------------------------------ configurazione */

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var cfg = Object.assign({
    productHandle: 'stampa-foto-configuratore',
    productId: 15979180228942,
    defaultSize: '10x15',
    maxDpi: 200,
    allowWhole: true,
    cartUrl: '/cart',
    rootUrl: '/'
  }, readJson('tpf-config') || {});
  cfg.maxDpi = Math.max(72, Math.min(400, Number(cfg.maxDpi) || 200));
  cfg.shipCents = Math.max(0, Math.round(Number(cfg.shipCents != null ? cfg.shipCents : 450)));
  cfg.freeFromCents = Math.max(0, Math.round(Number(cfg.freeFromCents != null ? cfg.freeFromCents : 6000)));
  // Foto per riga del carrello (impostazione della sezione): 30 come prima, fino a 1000 (provate al checkout).
  cfg.photosPerLine = Math.max(1, Math.min(1000, Math.round(Number(cfg.photosPerLine) || 30)));

  var UPLOAD_SHOP = 'personalizza-tela.myshopify.com';
  var UPLOAD_CONFIG = 'clvruqjhb2qh';
  var UPLOAD_BASE = 'https://foto.telapersonalizzata.com';
  var CART_PHOTOS_PER_LINE = cfg.photosPerLine;
  var MAX_FILE_BYTES = 50 * 1024 * 1024;
  var MAX_SOURCE_PIXELS = 100 * 1000 * 1000;
  var MAX_PER_SELECTION = 300;
  var MAX_ZOOM = 4;
  var THUMB_SIDE = 560;
  var TIERS = [
    { key: '1-19', min: 1 },
    { key: '20-99', min: 20 },
    { key: '100-199', min: 100 },
    { key: '200-399', min: 200 },
    { key: '400+', min: 400 }
  ];
  // Stesse soglie di tp-photo-check.js (usato anche da Ilaria).
  var Q = { great: 250, good: 180, medium: 120 };

  var DB_NAME = 'tp-direct-create';
  var DB_STORE = 'handoffs';
  var HANDOFF_MAX_AGE = 30 * 60 * 1000;
  // Il passaggio resta in memoria finché la pagina è aperta (Safari non legge più i file se lo si cancella):
  // si cancella quando la pagina si chiude; quelli rimasti si puliscono dopo 6 ore.
  var HANDOFF_KEEP = 6 * 60 * 60 * 1000;

  var ua = navigator.userAgent || '';
  var IS_IOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var IS_MOBILE = IS_IOS || /Android|Mobile/i.test(ua);
  var MAX_OUTPUT_PIXELS = IS_IOS ? 16 * 1000 * 1000 : (IS_MOBILE ? 24 * 1000 * 1000 : 40 * 1000 * 1000);

  var html = document.documentElement;
  function $(id) { return document.getElementById(id); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(n, digits) {
    var k = Math.pow(10, digits == null ? 2 : digits);
    return String(Math.round(Number(n) * k) / k).replace('.', ',');
  }
  function euro(cents) { return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function uid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return Date.now().toString(36) + Math.random().toString(36).slice(2);
  }
  function rndNumber(n) { return Math.floor(Math.random() * (9 * Math.pow(10, n - 1))) + Math.pow(10, n - 1); }
  function nextFrame() { return new Promise(function (r) { requestAnimationFrame(function () { r(); }); }); }

  /* ------------------------------------------------------------------ stato */

  var S = {
    variants: [],
    sizes: [],          // chiavi option1 nell'ordine del prodotto
    info: {},           // key -> informazioni sul formato
    materials: [],
    photos: [],
    defaults: { size: null, material: null, fit: 'fill' },
    reading: { total: 0, done: 0, active: false },
    queue: Promise.resolve(),
    productReady: null,
    busy: false,
    batches: [],        // _lotto_foto creati da questa pagina (per sostituire le righe se si riprova)
    inCart: false,      // le stampe sono già state aggiunte al carrello
    undo: null,
    setup: null,        // menu misura e carta aperto: { size, material }
    delivery: 'home',   // 'home' (a casa) | 'pickup' (ritiro in studio): solo preferenza, il metodo vero si sceglie al checkout
    dirty: false,
    editorId: null,
    pickerTarget: null  // { mode: 'bulk' } | { mode: 'photo', id }
  };

  /* ------------------------------------------------------------------ prodotto e formati */

  function parseSize(key) {
    var m = /^\s*(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)?\s*$/i.exec(String(key || ''));
    if (!m) return null;
    var a = parseFloat(m[1].replace(',', '.'));
    var b = m[2] ? parseFloat(m[2].replace(',', '.')) : 0;
    if (!a) return null;
    if (!b) {
      return { key: key, single: true, short: a, long: 0, area: a * a * 1.4,
        label: num(a) + ' cm · foto intera', short_label: num(a) + ' cm, foto intera',
        sub: 'lato lungo in base alla foto, non si taglia nulla' };
    }
    var s = Math.min(a, b), l = Math.max(a, b);
    return { key: key, single: false, short: s, long: l, ratio: l / s, area: s * l,
      label: num(s) + ' × ' + num(l) + ' cm', short_label: num(s) + '×' + num(l) + ' cm', sub: ratioName(l / s) };
  }
  function ratioName(r) {
    if (Math.abs(r - 1.5) < 0.02) return 'proporzione 3:2, come le reflex e molte fotocamere';
    if (Math.abs(r - 4 / 3) < 0.02) return 'proporzione 4:3, come le foto dello smartphone';
    if (Math.abs(r - 1.25) < 0.02) return 'proporzione 5:4';
    if (Math.abs(r - 1.2) < 0.02) return 'proporzione 6:5';
    if (Math.abs(r - 1.4) < 0.03) return 'proporzione 7:5';
    if (Math.abs(r - 1.462) < 0.03) return 'quasi 3:2';
    return '';
  }
  function groupOf(info) {
    if (info.single) return 'single';
    return info.long <= 22 ? 'classic' : 'large';
  }

  function tierFor(qty) {
    var q = Math.max(0, Number(qty) || 0), t = TIERS[0];
    for (var i = 0; i < TIERS.length; i++) if (q >= TIERS[i].min) t = TIERS[i];
    return t;
  }
  function nextTier(qty) {
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].min > qty) return TIERS[i];
    return null;
  }
  function variantFor(size, material, tierKey) {
    for (var i = 0; i < S.variants.length; i++) {
      var v = S.variants[i];
      if (v.option1 === size && v.option2 === material && v.option3 === tierKey) return v;
    }
    return null;
  }
  function unitPrice(size, material, qtyForSize) {
    var v = variantFor(size, material, tierFor(qtyForSize).key);
    return v ? v.price : null;
  }
  function minPrice(size) {
    var min = null;
    S.variants.forEach(function (v) { if (v.option1 === size && v.available !== false && (min == null || v.price < min)) min = v.price; });
    return min;
  }

  function setProduct(p) {
    if (!p || !Array.isArray(p.variants) || !p.variants.length) throw new Error('prodotto-vuoto');
    if (p.id && Number(p.id) !== Number(cfg.productId)) throw new Error('prodotto-diverso');
    S.variants = p.variants.map(function (v) {
      return { id: Number(v.id), option1: String(v.option1), option2: String(v.option2), option3: String(v.option3), price: Number(v.price), available: v.available !== false };
    });
    var sizes = [], mats = [];
    S.variants.forEach(function (v) {
      if (sizes.indexOf(v.option1) < 0) sizes.push(v.option1);
      if (mats.indexOf(v.option2) < 0) mats.push(v.option2);
    });
    S.sizes = sizes.filter(function (s) {
      var info = parseSize(s);
      if (!info) return false;
      // un formato si offre solo se la fascia base esiste ed è disponibile per ogni carta
      return mats.every(function (m) { var v = variantFor(s, m, '1-19'); return v && v.available; });
    });
    S.sizes.forEach(function (s) { S.info[s] = parseSize(s); });
    S.materials = mats;
    S.defaults.size = S.sizes.indexOf(cfg.defaultSize) >= 0 ? cfg.defaultSize : (S.sizes.indexOf('10x15') >= 0 ? '10x15' : S.sizes[0]);
    S.defaults.material = mats[0];
  }

  function loadProduct() {
    var inline = readJson('tpf-product');
    if (inline && inline.variants && inline.variants.length) {
      try { setProduct(inline); return Promise.resolve(); } catch (e) { /* si prova con la richiesta */ }
    }
    var attempt = function (n) {
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + cfg.productHandle + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(setProduct)
        .catch(function (err) {
          if (n < 3) return sleep(800 * n).then(function () { return attempt(n + 1); });
          throw err;
        });
    };
    return attempt(1);
  }

  function materialLabel(m) { return String(m).replace(/^Carta\s+/i, '').replace(/^./, function (c) { return c.toUpperCase(); }); }
  function materialHint(m) {
    if (/opac/i.test(m)) return 'senza riflessi, ideale per album e cornici';
    if (/lucid/i.test(m)) return 'colori brillanti e neri profondi';
    return '';
  }

  /* ------------------------------------------------------------------ geometria */

  // Foglio stampato in cm, con l'orientamento della foto (o girato se richiesto).
  function frame(p) {
    var info = S.info[p.size] || parseSize(p.size);
    if (!info) return { W: 10, H: 15, single: false };
    if (info.single) {
      var r = Math.max(p.w, p.h) / Math.min(p.w, p.h);
      var longCm = info.short * r;
      return p.w >= p.h ? { W: longCm, H: info.short, single: true, landscape: true } : { W: info.short, H: longCm, single: true, landscape: false };
    }
    var landscape = (p.w >= p.h) !== !!p.swap;
    return landscape ? { W: info.long, H: info.short, single: false, landscape: true } : { W: info.short, H: info.long, single: false, landscape: false };
  }
  function isWhole(p) { return cfg.allowWhole && p.fit === 'whole' && !frame(p).single; }
  // Parte della foto che finisce sul foglio (pixel della foto).
  function crop(p) {
    var f = frame(p);
    if (f.single || isWhole(p)) return { sx: 0, sy: 0, sw: p.w, sh: p.h };
    var r = f.W / f.H, sw, sh;
    if (p.w / p.h > r) { sh = p.h; sw = p.h * r; } else { sw = p.w; sh = p.w / r; }
    var z = clamp(Number(p.zoom) || 1, 1, MAX_ZOOM);
    sw /= z; sh /= z;
    return { sx: clamp(p.fx, 0, 1) * (p.w - sw), sy: clamp(p.fy, 0, 1) * (p.h - sh), sw: sw, sh: sh };
  }
  // Posizione della foto intera sul foglio (cm), per "Foto intera".
  function placed(p) {
    var f = frame(p);
    var pw = Math.min(f.W, f.H * p.w / p.h);
    return { W: pw, H: pw * p.h / p.w, F: f };
  }
  function dpiOf(p) {
    var f = frame(p);
    if (isWhole(p)) { var pl = placed(p); return p.w / (pl.W / 2.54); }
    var c = crop(p);
    return Math.min(c.sw / (f.W / 2.54), c.sh / (f.H / 2.54));
  }
  // dpi massimi che il file può avere con il tetto di pixel del dispositivo (16 MP su iPhone)
  function capDpi(p) {
    var f = frame(p);
    return Math.sqrt(MAX_OUTPUT_PIXELS / ((f.W / 2.54) * (f.H / 2.54)));
  }
  function qualityOf(p) {
    var dpi = Math.round(Math.min(dpiOf(p), capDpi(p)));
    if (dpi >= Q.great) return { dpi: dpi, code: 'great', label: 'Ottima' };
    if (dpi >= Q.good) return { dpi: dpi, code: 'good', label: 'Buona' };
    if (dpi >= Q.medium) return { dpi: dpi, code: 'medium', label: 'Sufficiente' };
    return { dpi: dpi, code: 'low', label: 'Bassa' };
  }
  function cutShare(p) {
    var f = frame(p);
    if (f.single || isWhole(p)) return 0;
    var c = crop(p);
    return 1 - (c.sw * c.sh) / (p.w * p.h);
  }
  function baseCutShare(p, size, swap) {
    var q = Object.assign({}, p, { size: size, swap: swap == null ? p.swap : swap, zoom: 1, fit: 'fill' });
    return cutShare(q);
  }
  // Formato più grande con qualità almeno buona, per il consiglio sulle foto con pochi pixel.
  function bestSizeFor(p) {
    var best = null;
    S.sizes.forEach(function (s) {
      var q = Object.assign({}, p, { size: s, zoom: 1 });
      if (qualityOf(q).dpi >= Q.good && (!best || S.info[s].area > S.info[best].area)) best = s;
    });
    return best;
  }
  function sizeLabelFor(p) {
    var info = S.info[p.size];
    if (!info) return p.size;
    if (!info.single) return info.label;
    var f = frame(p);
    return num(Math.min(f.W, f.H), 1) + ' × ' + num(Math.max(f.W, f.H), 1) + ' cm';
  }

  /* ------------------------------------------------------------------ prezzi */

  function copiesBySize() {
    var t = {};
    S.photos.forEach(function (p) { t[p.size] = (t[p.size] || 0) + p.qty; });
    return t;
  }
  function priceOf(p, bySize) {
    var u = unitPrice(p.size, p.material, (bySize || copiesBySize())[p.size] || p.qty);
    return u == null ? 0 : u * p.qty;
  }
  function totals() {
    var bySize = copiesBySize(), lines = {}, total = 0, copies = 0;
    S.photos.forEach(function (p) {
      var key = p.size + '|' + p.material;
      var tier = tierFor(bySize[p.size]);
      var v = variantFor(p.size, p.material, tier.key);
      var line = lines[key] || (lines[key] = { size: p.size, material: p.material, qty: 0, photos: 0, unit: v ? v.price : 0, tier: tier.key, variant: v ? v.id : null });
      line.qty += p.qty; line.photos += 1;
      total += (v ? v.price : 0) * p.qty;
      copies += p.qty;
    });
    return { lines: lines, bySize: bySize, total: total, copies: copies };
  }

  /* ------------------------------------------------------------------ lettura delle foto */

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('decode')); };
      img.src = src;
    });
  }
  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve) {
      if (canvas.toBlob) canvas.toBlob(resolve, type, quality);
      else resolve(null);
    });
  }

  function fileProblem(file) {
    var name = String(file.name || '');
    var type = String(file.type || '').toLowerCase();
    var okType = /^image\/(jpeg|jpg|pjpeg|png|webp|heic|heif)$/.test(type) || /\.(jpe?g|png|webp|heic|heif)$/i.test(name);
    if (!okType) return 'formato non supportato (usa JPG o PNG)';
    if (file.size > MAX_FILE_BYTES) return 'supera ' + Math.round(MAX_FILE_BYTES / 1048576) + ' MB';
    return '';
  }

  async function readOne(file) {
    var url = URL.createObjectURL(file);
    var img;
    try {
      img = await loadImage(url);
    } catch (e) {
      URL.revokeObjectURL(url);
      if (/\.(heic|heif)$/i.test(file.name || '') || /heic|heif/i.test(file.type || '')) {
        throw new Error('foto HEIC che questo browser non apre: esportala in JPG oppure sceglila dalla Galleria del telefono');
      }
      throw new Error('file danneggiato o troppo pesante per la memoria del dispositivo');
    }
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) { URL.revokeObjectURL(url); throw new Error('dimensioni non leggibili'); }
    if (w * h > MAX_SOURCE_PIXELS) { URL.revokeObjectURL(url); throw new Error(num(w * h / 1e6, 0) + ' megapixel, il limite è 100'); }
    var s = Math.min(1, THUMB_SIDE / Math.max(w, h));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * s));
    c.height = Math.max(1, Math.round(h * s));
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, c.width, c.height);
    var blob = await canvasToBlob(c, 'image/jpeg', 0.84);
    c.width = c.height = 1;
    img.src = '';
    return { url: url, thumb: blob ? URL.createObjectURL(blob) : url, w: w, h: h };
  }

  function newPhoto(file, data, opts) {
    return {
      id: uid(),
      name: file.name || 'foto.jpg',
      file: file,
      url: data.url,
      thumb: data.thumb,
      w: data.w,
      h: data.h,
      size: opts.size || S.defaults.size,
      material: opts.material || S.defaults.material,
      fit: opts.fit || S.defaults.fit,
      swap: false,
      qty: 1,
      zoom: 1,
      fx: 0.5,
      fy: 0.5,
      selected: false,
      upload: null
    };
  }

  function addFiles(list, opts) {
    opts = opts || {};
    var files = Array.prototype.slice.call(list || []);
    if (!files.length) return S.queue;
    var job = async function () {
      await S.productReady;
      if (!S.variants.length) {
        showNotice('Formati e prezzi non sono ancora disponibili: ricarica la pagina e scegli di nuovo le foto.');
        return;
      }
      var problems = [];
      var accepted = [];
      files.forEach(function (f) {
        var why = fileProblem(f);
        if (why) problems.push(f.name + ' — ' + why); else accepted.push(f);
      });
      if (accepted.length > MAX_PER_SELECTION) {
        problems.push((accepted.length - MAX_PER_SELECTION) + ' foto oltre le ' + MAX_PER_SELECTION + ' di questa selezione: aggiungile con una nuova selezione');
        accepted = accepted.slice(0, MAX_PER_SELECTION);
      }
      var first = !S.photos.length && accepted.length > 0;
      if (opts.size && S.sizes.indexOf(opts.size) >= 0 && first) S.defaults.size = opts.size;
      S.reading.total += accepted.length;
      S.reading.active = true;
      showWork();
      renderReading();
      if (first && !opts.noSetup && !S.setup) openSetup(opts.size || S.defaults.size);
      try {
      for (var i = 0; i < accepted.length; i++) {
        var file = accepted[i];
        try {
          var data = await readOne(file);
          var p = newPhoto(file, data, {});
          S.photos.push(p);
          appendCard(p);
          S.dirty = true;
        } catch (err) {
          problems.push(file.name + ' — ' + (err && err.message ? err.message : 'non leggibile'));
        }
        S.reading.done += 1;
        if (i % 4 === 3 || i === accepted.length - 1) { renderReading(); renderSummary(); renderToolbar(); if (S.setup) renderSetup(); }
        // lascia respirare il browser nelle selezioni grandi
        await (IS_IOS ? sleep(12) : nextFrame());
      }
      } finally {
        S.reading.active = false;
        S.reading.total = 0; S.reading.done = 0;
        renderReading();
        renderAll();
        if (S.setup) renderSetup();
      }
      if (!first && accepted.length && S.photos.length && !problems.length) {
        var d = S.info[S.defaults.size];
        showNotice(plural(accepted.length, 'foto aggiunta', 'foto aggiunte') + ' in ' + (d ? d.label : S.defaults.size) + ', carta ' + materialLabel(S.defaults.material).toLowerCase() + '.', 'info');
      }
      if (!S.photos.length && S.setup) { S.setup = null; closeModal('tpf-setup'); }
      if (problems.length) showNotice(problems);
      if (!S.photos.length) showEmpty();
    };
    var run = S.queue.then(job, job);
    S.queue = run.catch(function () {});
    return run;
  }

  /* ------------------------------------------------------------------ interfaccia: pagina */

  var els = {};
  function cacheEls() {
    ['tpf-file', 'tpf-empty', 'tpf-work', 'tpf-grid', 'tpf-bar', 'tpf-cta', 'tpf-bar-cta', 'tpf-count', 'tpf-lines', 'tpf-total', 'tpf-bar-count', 'tpf-bar-total',
      'tpf-subtotal', 'tpf-ship-label', 'tpf-ship-value', 'tpf-ship-note', 'tpf-delivery', 'tpf-del-home',
      'tpf-scope', 'tpf-select-all', 'tpf-select-none', 'tpf-remove-selected', 'tpf-bulk-size', 'tpf-bulk-size-v', 'tpf-bulk-material', 'tpf-bulk-fit',
      'tpf-reading', 'tpf-reading-bar', 'tpf-reading-text', 'tpf-notice', 'tpf-pricelist', 'tpf-empty-status', 'tpf-dropveil'].forEach(function (id) {
      els[id.replace('tpf-', '').replace(/-([a-z])/g, function (m, c) { return c.toUpperCase(); })] = $(id);
    });
  }

  function showWork() {
    els.empty.hidden = true;
    els.work.hidden = false;
    els.bar.hidden = false;
    root.dataset.state = 'work';
    html.classList.add('tpf-has-photos');
    setSteps(2);
  }
  function showEmpty() {
    els.empty.hidden = false;
    els.work.hidden = true;
    els.bar.hidden = true;
    root.dataset.state = 'empty';
    html.classList.remove('tpf-has-photos');
    setSteps(1);
  }
  function setSteps(n) {
    [1, 2, 3].forEach(function (i) {
      var li = $('tpf-step-' + i);
      if (!li) return;
      li.classList.toggle('is-done', i < n);
      li.classList.toggle('is-current', i === n);
      if (i === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
    var t = $('tpf-head-step');
    if (t) t.textContent = 'Passo ' + n + ' di 3';
  }

  function renderPricelist() {
    if (!els.pricelist || !S.sizes.length) return;
    var groups = { classic: [], single: [], large: [] };
    S.sizes.forEach(function (s) { groups[groupOf(S.info[s])].push(s); });
    var names = { classic: 'Stampe classiche', single: 'Foto intera, senza tagli', large: 'Ingrandimenti' };
    var out = '<h2>Formati e prezzi per copia</h2><div class="tpf-pricegroups">';
    ['classic', 'single', 'large'].forEach(function (g) {
      if (!groups[g].length) return;
      out += '<div><h3>' + names[g] + '</h3><ul>';
      groups[g].sort(function (a, b) { return S.info[a].area - S.info[b].area; }).forEach(function (s) {
        var base = unitPrice(s, S.materials[0], 1), min = minPrice(s);
        out += '<li><span>' + esc(S.info[s].label) + '</span><strong>' + euro(base) + '</strong>' +
          (min != null && min < base ? '<em>da ' + euro(min) + '</em>' : '<em></em>') + '</li>';
      });
      out += '</ul></div>';
    });
    out += '</div><p class="tpf-muted">Dove c\'è «da», il prezzo per copia scende da solo con 20, 100, 200 e 400 copie dello stesso formato. Stesso prezzo per carta lucida e opaca.</p>';
    els.pricelist.innerHTML = out;
  }

  function renderReading() {
    var r = S.reading;
    if (!r.active || !r.total) { els.reading.hidden = true; els.emptyStatus.textContent = ''; return; }
    els.reading.hidden = false;
    els.readingBar.style.width = Math.round(r.done / r.total * 100) + '%';
    els.readingText.textContent = 'Preparo le anteprime: ' + r.done + ' di ' + r.total + '. Intanto puoi già modificare le foto pronte.';
    els.emptyStatus.textContent = 'Preparo le foto: ' + r.done + ' di ' + r.total;
  }

  var noticeTimer = 0;
  function showNotice(lines, tone) {
    var n = els.notice;
    if (!n) return;
    var list = Array.isArray(lines) ? lines : [lines];
    var head = tone === 'info' ? '' : '<strong>' + (list.length === 1 ? 'Un file non è stato aggiunto' : list.length + ' file non sono stati aggiunti') + '</strong>';
    n.className = 'tpf-notice' + (tone === 'info' ? ' is-info' : '');
    n.innerHTML = '<div>' + head + '<ul>' + list.slice(0, 8).map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') +
      (list.length > 8 ? '<li>… e altri ' + (list.length - 8) + '</li>' : '') + '</ul></div><button type="button" class="tpf-icon-btn" aria-label="Chiudi avviso">×</button>';
    n.hidden = false;
    n.querySelector('button').addEventListener('click', function () { n.hidden = true; });
    clearTimeout(noticeTimer);
    if (tone === 'info') noticeTimer = setTimeout(function () { n.hidden = true; }, 6000);
    if (!els.work.hidden) n.scrollIntoView({ block: 'nearest' });
    else if (els.emptyStatus) els.emptyStatus.textContent = list.join(' · ');
  }

  // Ridisegna un pezzo di interfaccia e rimette il fuoco sul pulsante equivalente.
  function keepFocus(container, fn) {
    var a = document.activeElement;
    var attr = null, val = null;
    if (a && container && container.contains(a)) {
      ['data-material', 'data-fit', 'data-size'].forEach(function (n) { if (a.hasAttribute(n)) { attr = n; val = a.getAttribute(n); } });
    }
    fn();
    if (attr) {
      var again = container.querySelector('[' + attr + '="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
      if (again) again.focus();
    }
  }

  /* ---- barra "per tutte / per le selezionate" */

  function scopePhotos() {
    var sel = S.photos.filter(function (p) { return p.selected; });
    return sel.length ? sel : S.photos;
  }
  function commonValue(list, key) {
    if (!list.length) return null;
    var v = list[0][key];
    for (var i = 1; i < list.length; i++) if (list[i][key] !== v) return null;
    return v;
  }
  function segHtml(options, current, attr) {
    return options.map(function (o) {
      var on = o.value === current;
      return '<button type="button" ' + attr + '="' + esc(o.value) + '" aria-pressed="' + on + '"' + (o.disabled ? ' disabled' : '') + (o.title ? ' title="' + esc(o.title) + '"' : '') + '>' + esc(o.label) + '</button>';
    }).join('');
  }
  function fitOptions(list, short) {
    var singleOnly = list.length && list.every(function (p) { return frame(p).single; });
    return [
      { value: 'fill', label: short ? 'Riempi' : 'Riempi il foglio', title: 'La foto copre tutto il foglio: si taglia quello che avanza' },
      { value: 'whole', label: 'Foto intera', disabled: singleOnly, title: 'La foto non si taglia: restano bordi bianchi dove la forma è diversa' }
    ];
  }
  function renderToolbar() {
    keepFocus($('tpf-toolbar'), renderToolbarNow);
  }
  function renderToolbarNow() {
    var sel = S.photos.filter(function (p) { return p.selected; }).length;
    var list = scopePhotos();
    els.scope.innerHTML = sel ? 'Modifichi <strong>' + plural(sel, 'foto selezionata', 'foto selezionate') + '</strong>' : 'Per tutte le <strong>' + plural(S.photos.length, 'foto', 'foto') + '</strong>';
    if (S.photos.length === 1) els.scope.innerHTML = 'La tua foto';
    $('tpf-toolbar').classList.toggle('is-selecting', sel > 0);
    els.selectAll.hidden = S.photos.length < 2 || sel === S.photos.length;
    els.selectNone.hidden = !sel;
    els.removeSelected.hidden = !sel;
    var size = commonValue(list, 'size');
    els.bulkSizeV.textContent = size ? (S.info[size] ? S.info[size].short_label : size) : 'Diversi';
    var mat = commonValue(list, 'material');
    els.bulkMaterial.innerHTML = segHtml(S.materials.map(function (m) { return { value: m, label: materialLabel(m), title: materialHint(m) }; }), mat, 'data-material');
    if (cfg.allowWhole) {
      var fit = commonValue(list, 'fit');
      els.bulkFit.innerHTML = segHtml(fitOptions(list, true), fit, 'data-fit');
      els.bulkFit.hidden = false;
    } else {
      els.bulkFit.hidden = true;
    }
  }

  function applyToScope(change) {
    var list = scopePhotos();
    list.forEach(function (p) {
      Object.keys(change).forEach(function (k) { p[k] = change[k]; });
      if (change.size) { p.zoom = 1; }
    });
    S.dirty = true;
    list.forEach(updateCard);
    renderToolbar();
    renderSummary();
  }

  /* ---- griglia */

  function paperStyle(p) {
    var f = frame(p);
    var r = f.W / f.H;
    // il foglio sta in un riquadro quadrato: lato lungo all'88 %
    return r >= 1 ? 'width:88%;aspect-ratio:' + f.W.toFixed(3) + '/' + f.H.toFixed(3) : 'width:' + (88 * r).toFixed(2) + '%;aspect-ratio:' + f.W.toFixed(3) + '/' + f.H.toFixed(3);
  }
  function imgStyle(p) {
    if (isWhole(p)) {
      var pl = placed(p);
      var wPct = pl.W / pl.F.W * 100, hPct = pl.H / pl.F.H * 100;
      return 'left:' + ((100 - wPct) / 2).toFixed(3) + '%;top:' + ((100 - hPct) / 2).toFixed(3) + '%;width:' + wPct.toFixed(3) + '%;height:' + hPct.toFixed(3) + '%';
    }
    var c = crop(p);
    return 'left:' + (-c.sx / c.sw * 100).toFixed(3) + '%;top:' + (-c.sy / c.sh * 100).toFixed(3) + '%;width:' + (p.w / c.sw * 100).toFixed(3) + '%;height:' + (p.h / c.sh * 100).toFixed(3) + '%';
  }
  function qualityBadge(q) {
    if (q.code === 'low') return '<span class="tpf-badge is-low" title="' + q.dpi + ' dpi">Pochi pixel</span>';
    if (q.code === 'medium') return '<span class="tpf-badge is-medium" title="' + q.dpi + ' dpi">Qualità sufficiente</span>';
    return '';
  }

  function cardInner(p) {
    var q = qualityOf(p);
    var matCls = /lucid/i.test(p.material) ? ' is-gloss' : '';
    return '' +
      '<div class="tpf-card-stage">' +
        '<button type="button" class="tpf-card-open" data-act="edit" aria-label="Modifica ' + esc(p.name) + '">' +
          '<span class="tpf-paper' + matCls + '" style="' + paperStyle(p) + '"><img src="' + esc(p.thumb) + '" alt="" loading="lazy" decoding="async" draggable="false" style="' + imgStyle(p) + '"></span>' +
        '</button>' +
        '<label class="tpf-check" title="Seleziona"><input type="checkbox" data-act="select"' + (p.selected ? ' checked' : '') + ' aria-label="Seleziona ' + esc(p.name) + '"><span aria-hidden="true"></span></label>' +
        '<button type="button" class="tpf-card-del" data-act="delete" aria-label="Elimina ' + esc(p.name) + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg></button>' +
        qualityBadge(q) +
      '</div>' +
      '<div class="tpf-card-body">' +
        '<p class="tpf-card-size"><strong>' + esc(sizeLabelFor(p)) + '</strong><span>' + esc(materialLabel(p.material)) + (isWhole(p) ? ' · foto intera' : '') + '</span></p>' +
        '<div class="tpf-card-row">' +
          '<div class="tpf-stepper tpf-stepper-sm">' +
            '<button type="button" data-act="minus" aria-label="Una copia in meno">−</button>' +
            '<input type="number" inputmode="numeric" min="1" max="999" step="1" value="' + p.qty + '" data-act="qty" aria-label="Copie di ' + esc(p.name) + '">' +
            '<button type="button" data-act="plus" aria-label="Una copia in più">+</button>' +
          '</div>' +
          '<button type="button" class="tpf-card-edit" data-act="edit">Modifica</button>' +
        '</div>' +
      '</div>';
  }
  function appendCard(p) {
    var li = document.createElement('li');
    li.className = 'tpf-card' + (p.selected ? ' is-selected' : '');
    li.id = 'tpf-card-' + p.id;
    li.dataset.id = p.id;
    li.innerHTML = cardInner(p);
    els.grid.appendChild(li);
  }
  function updateCard(p) {
    var li = $('tpf-card-' + p.id);
    if (!li) return;
    var active = document.activeElement && li.contains(document.activeElement) ? document.activeElement.getAttribute('data-act') : null;
    li.className = 'tpf-card' + (p.selected ? ' is-selected' : '');
    li.innerHTML = cardInner(p);
    if (active) { var again = li.querySelector('[data-act="' + active + '"]'); if (again) again.focus(); }
  }
  function renderGrid() {
    els.grid.innerHTML = '';
    S.photos.forEach(appendCard);
  }

  // Le foto rimosse restano recuperabili con "Annulla" finché non se ne rimuovono altre.
  function releasePhotos(list, keep) {
    list.forEach(function (p) {
      var stillUsed = S.photos.some(function (o) { return o.url === p.url; }) || (keep || []).some(function (r) { return r.p.url === p.url; });
      if (stillUsed) return;
      try { URL.revokeObjectURL(p.url); if (p.thumb !== p.url) URL.revokeObjectURL(p.thumb); } catch (e) { /* già revocato */ }
    });
  }
  function removePhotos(ids, opts) {
    opts = opts || {};
    var set = {};
    ids.forEach(function (id) { set[id] = true; });
    var removed = [];
    S.photos = S.photos.filter(function (p, idx) {
      if (!set[p.id]) return true;
      var li = $('tpf-card-' + p.id);
      if (li) li.remove();
      removed.push({ p: p, idx: idx });
      return false;
    });
    if (S.undo) releasePhotos(S.undo.map(function (r) { return r.p; }), removed);
    S.undo = removed.length ? removed : null;
    S.dirty = S.photos.length > 0;
    if (!S.photos.length) { showEmpty(); }
    renderToolbar();
    renderSummary();
    if (removed.length && !opts.silent) showUndo(removed.length);
  }
  function undoRemove() {
    if (!S.undo) return;
    var items = S.undo.slice().sort(function (a, b) { return a.idx - b.idx; });
    S.undo = null;
    items.forEach(function (r) { r.p.selected = false; S.photos.splice(Math.min(r.idx, S.photos.length), 0, r.p); });
    showWork();
    renderGrid();
    renderAll();
    S.dirty = true;
    els.notice.hidden = true;
    emptyUndo(false);
  }
  function showUndo(n) {
    var text = n === 1 ? 'Foto rimossa.' : n + ' foto rimosse.';
    if (els.work.hidden) { emptyUndo(true, text); return; }
    var box = els.notice;
    box.className = 'tpf-notice is-info';
    box.innerHTML = '<div>' + esc(text) + ' <button type="button" class="tpf-link" data-tpf-undo>Annulla</button></div><button type="button" class="tpf-icon-btn" aria-label="Chiudi avviso">×</button>';
    box.hidden = false;
    box.querySelector('.tpf-icon-btn').addEventListener('click', function () { box.hidden = true; });
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () { box.hidden = true; }, 8000);
  }
  function emptyUndo(show, text) {
    var st = els.emptyStatus;
    if (!st) return;
    if (!show) { st.textContent = ''; return; }
    st.innerHTML = esc(text) + ' <button type="button" class="tpf-link" data-tpf-undo>Annulla</button>';
  }

  /* ---- riepilogo */

  function renderSummary() {
    var t = totals();
    var nPhotos = S.photos.length;
    els.count.textContent = plural(nPhotos, 'foto', 'foto') + ' · ' + plural(t.copies, 'stampa', 'stampe');
    var bySizeLines = {};
    Object.keys(t.lines).forEach(function (k) {
      var l = t.lines[k];
      (bySizeLines[l.size] = bySizeLines[l.size] || []).push(l);
    });
    var order = S.sizes.filter(function (s) { return bySizeLines[s]; });
    var out = '';
    order.forEach(function (size) {
      var info = S.info[size];
      var copies = t.bySize[size];
      var tier = tierFor(copies);
      out += '<div class="tpf-line-group">';
      bySizeLines[size].forEach(function (l) {
        out += '<div class="tpf-line"><span><strong>' + esc(info ? info.label : size) + '</strong> · ' + esc(materialLabel(l.material)) +
          '<small>' + plural(l.qty, 'copia', 'copie') + ' × ' + euro(l.unit) + '</small></span><b>' + euro(l.unit * l.qty) + '</b></div>';
      });
      if (tier.min > 1) out += '<p class="tpf-line-note is-ok">Sconto quantità: prezzo da ' + tier.min + ' copie</p>';
      var nt = nextTier(copies);
      if (nt) {
        var missing = nt.min - copies;
        var mat = bySizeLines[size][0].material;
        var nowUnit = unitPrice(size, mat, copies), nextUnit = unitPrice(size, mat, nt.min);
        if (nextUnit != null && nowUnit != null && nextUnit < nowUnit) {
          var nowTotal = 0;
          bySizeLines[size].forEach(function (l) { nowTotal += l.unit * l.qty; });
          var nextTotal = nextUnit * nt.min;
          if (nextTotal <= nowTotal) {
            out += '<p class="tpf-line-note is-tip">Con ' + plural(missing, 'copia', 'copie') + ' in più di questo formato paghi ' + euro(nextUnit) + ' a copia e spendi meno: ' + euro(nextTotal) + ' invece di ' + euro(nowTotal) + '.</p>';
          } else if (missing <= Math.max(5, Math.round(nt.min * 0.2))) {
            out += '<p class="tpf-line-note is-tip">Da ' + nt.min + ' copie di questo formato il prezzo scende a ' + euro(nextUnit) + ' (ne mancano ' + missing + ').</p>';
          }
        }
      }
      out += '</div>';
    });
    els.lines.innerHTML = out || '<p class="tpf-muted">Nessuna foto.</p>';
    var ship = shippingFor(t.total);
    var grand = t.total + ship;
    renderDelivery(t.total, ship);
    els.total.textContent = euro(grand);
    els.barCount.textContent = plural(t.copies, 'stampa', 'stampe') + (S.delivery === 'pickup' ? ' · ritiro in studio' : (ship ? ' · spedizione inclusa' : ' · spedizione gratis'));
    els.barTotal.textContent = euro(grand);
    var ready = nPhotos > 0 && !S.reading.active && !S.busy;
    els.cta.disabled = !ready;
    els.barCta.disabled = !ready;
    var verb = S.inCart ? 'Aggiorna il carrello' : 'Aggiungi al carrello';
    var label = S.reading.active ? 'Attendi le anteprime…' : verb;
    els.cta.textContent = label + (ready ? ' · ' + euro(grand) : '');
    els.barCta.textContent = S.reading.active ? 'Attendi…' : verb;
  }

  // Spedizione come nel profilo Shopify delle stampe: a pagamento sotto la soglia, gratis sopra; ritiro gratis.
  function shippingFor(subtotal) {
    if (S.delivery === 'pickup') return 0;
    if (cfg.freeFromCents > 0 && subtotal >= cfg.freeFromCents) return 0;
    return cfg.shipCents;
  }
  function renderDelivery(subtotal, ship) {
    if (!els.delivery) return;
    Array.prototype.forEach.call(els.delivery.querySelectorAll('[data-delivery]'), function (b) {
      var on = b.getAttribute('data-delivery') === S.delivery;
      b.setAttribute('aria-checked', String(on));
      b.tabIndex = on ? 0 : -1;
    });
    var free = cfg.freeFromCents > 0 && subtotal >= cfg.freeFromCents;
    if (els.delHome) els.delHome.textContent = free ? 'gratis' : euro(cfg.shipCents) + (cfg.freeFromCents > 0 ? ' · gratis da ' + euro(cfg.freeFromCents).replace(',00', '') : '');
    els.subtotal.textContent = euro(subtotal);
    if (S.delivery === 'pickup') {
      els.shipLabel.textContent = 'Ritiro in studio';
      els.shipValue.textContent = 'gratis';
      els.shipNote.textContent = cfg.pickup + '. ' + (cfg.pickupNote ? cfg.pickupNote + '. ' : '') + 'Lo confermi al checkout.';
    } else {
      els.shipLabel.textContent = 'Spedizione a casa';
      els.shipValue.textContent = ship ? euro(ship) : 'gratis';
      var missing = cfg.freeFromCents - subtotal;
      var head = ship && cfg.freeFromCents > 0 && subtotal > 0 ? 'Mancano ' + euro(missing) + ' di stampe per la spedizione gratuita. ' : (ship ? '' : 'Spedizione gratuita. ');
      els.shipNote.textContent = head + (cfg.delivery || '') + '.';
    }
  }
  function setDelivery(value) {
    S.delivery = value === 'pickup' ? 'pickup' : 'home';
    try { sessionStorage.setItem('tpf-delivery', S.delivery); } catch (e) { /* facoltativo */ }
    renderSummary();
  }
  // Salva la preferenza nel carrello, come il configuratore della tela (attributo «Consegna preferita»).
  async function saveDeliveryPreference() {
    try {
      await fetchWithTimeout((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ attributes: { 'Consegna preferita': S.delivery === 'pickup' ? 'Ritiro in studio' : 'A casa' } })
      }, 15000);
    } catch (e) { /* solo una preferenza: il metodo si sceglie al checkout */ }
  }

  function renderAll() {
    renderToolbar();
    renderSummary();
  }

  /* ------------------------------------------------------------------ scelta del formato */

  // Elenco dei formati: prezzo per copia, proporzione, "Adatto alle tue foto", "Pochi pixel".
  function formatsHtml(list, current) {
    var groups = { classic: [], single: [], large: [] };
    S.sizes.forEach(function (s) { groups[groupOf(S.info[s])].push(s); });
    var names = { classic: 'Stampe classiche', single: 'Foto intera: il lato lungo segue la foto', large: 'Ingrandimenti' };
    var out = '';
    ['classic', 'single', 'large'].forEach(function (g) {
      if (!groups[g].length) return;
      out += '<h3>' + names[g] + '</h3><div class="tpf-fmt-group">';
      groups[g].sort(function (a, b) { return S.info[a].area - S.info[b].area; }).forEach(function (s) {
        var info = S.info[s];
        var fit = 0, low = 0;
        list.forEach(function (p) {
          if (info.single || baseCutShare(p, s) <= 0.03) fit++;
          var q = qualityOf(Object.assign({}, p, { size: s, zoom: 1 }));
          if (q.code === 'low') low++;
        });
        var tags = '';
        if (info.single) tags += '<span class="tpf-tag is-ok">Nessun taglio</span>';
        else if (list.length && fit / list.length >= 0.6) tags += '<span class="tpf-tag is-ok">Adatto alle tue foto</span>';
        if (low) tags += '<span class="tpf-tag is-low">' + (list.length === 1 ? 'Pochi pixel' : 'Pochi pixel per ' + low + ' foto') + '</span>';
        var base = unitPrice(s, S.materials[0], 1), min = minPrice(s);
        out += '<button type="button" class="tpf-fmt' + (s === current ? ' is-current' : '') + '" data-size="' + esc(s) + '" aria-pressed="' + (s === current) + '">' +
          '<span class="tpf-fmt-shape" aria-hidden="true"><i style="' + shapeStyle(info) + '"></i></span>' +
          '<span class="tpf-fmt-text"><strong>' + esc(info.label) + '</strong><small>' + esc(info.sub || '') + '</small>' + (tags ? '<span class="tpf-fmt-tags">' + tags + '</span>' : '') + '</span>' +
          '<span class="tpf-fmt-price"><strong>' + euro(base) + '</strong>' + (min != null && min < base ? '<small>da ' + euro(min) + '</small>' : '') + '</span>' +
          '</button>';
      });
      out += '</div>';
    });
    return out;
  }
  function openFormats(target) {
    S.pickerTarget = target;
    var list = target.mode === 'photo' ? S.photos.filter(function (p) { return p.id === target.id; }) : scopePhotos();
    var current = commonValue(list, 'size');
    var sub = target.mode === 'photo' ? 'Per questa foto' : (S.photos.some(function (p) { return p.selected; }) ? 'Per ' + plural(list.length, 'foto selezionata', 'foto selezionate') : 'Per ' + (list.length === 1 ? 'la tua foto' : 'tutte le ' + list.length + ' foto'));
    $('tpf-formats-sub').textContent = sub;
    $('tpf-formats-list').innerHTML = formatsHtml(list, current);
    openModal('tpf-formats');
    var cur = $('tpf-formats-list').querySelector('.is-current') || $('tpf-formats-list').querySelector('.tpf-fmt');
    if (cur) cur.focus();
  }
  function shapeStyle(info) {
    var maxSide = 26;
    if (info.single) return 'width:' + maxSide * 0.75 + 'px;height:' + maxSide + 'px;border-style:dashed';
    var sc = maxSide / info.long;
    return 'width:' + Math.max(8, Math.round(info.short * sc)) + 'px;height:' + maxSide + 'px';
  }
  function chooseFormat(size) {
    var t = S.pickerTarget;
    closeModal('tpf-formats');
    if (!t || S.sizes.indexOf(size) < 0) return;
    if (t.mode === 'photo') {
      var p = findPhoto(t.id);
      if (!p) return;
      p.size = size; p.zoom = 1;
      S.dirty = true;
      updateCard(p);
      renderAll();
      renderEditor();
      var b = $('tpf-ed-size'); if (b) b.focus();
    } else {
      applyToScope({ size: size });
      S.defaults.size = size;
      els.bulkSize.focus();
    }
  }

  /* ------------------------------------------------------------------ misura e carta dopo la scelta delle foto */

  function setupCount() {
    return S.photos.length + (S.reading.active ? Math.max(0, S.reading.total - S.reading.done) : 0);
  }
  function openSetup(size) {
    S.setup = {
      size: S.sizes.indexOf(size) >= 0 ? size : S.defaults.size,
      material: S.defaults.material
    };
    renderSetup();
    openModal('tpf-setup');
    var body = document.querySelector('#tpf-setup .tpf-setup-body');
    if (body) body.scrollTop = 0;
    setTimeout(function () {
      try { document.querySelector('#tpf-setup .tpf-setup-box').focus({ preventScroll: true }); } catch (e) { /* facoltativo */ }
    }, 30);
  }
  function renderSetup() {
    if (!S.setup) return;
    var n = setupCount();
    $('tpf-setup-sub').textContent = (n === 1 ? 'Hai scelto 1 foto.' : 'Hai scelto ' + n + ' foto.') + ' Potrai cambiare misura e carta anche per ogni singola foto.';
    keepFocus($('tpf-setup'), function () {
      $('tpf-setup-sizes').innerHTML = formatsHtml(S.photos, S.setup.size);
      $('tpf-setup-papers').innerHTML = segHtml(S.materials.map(function (m) { return { value: m, label: materialLabel(m), title: materialHint(m) }; }), S.setup.material, 'data-material');
    });
    var info = S.info[S.setup.size];
    var unit = unitPrice(S.setup.size, S.setup.material, n);
    $('tpf-setup-summary').innerHTML = unit == null || !n ? '' :
      '<span>' + plural(n, 'stampa', 'stampe') + ' ' + esc(info ? info.label : S.setup.size) + ', carta ' + esc(materialLabel(S.setup.material).toLowerCase()) + '</span><strong>' + euro(unit * n) + '</strong>';
  }
  function closeSetup() {
    if (!S.setup) { closeModal('tpf-setup'); return; }
    var size = S.setup.size, material = S.setup.material;
    S.setup = null;
    S.defaults.size = size;
    S.defaults.material = material;
    S.photos.forEach(function (p) {
      if (p.size !== size) { p.size = size; p.zoom = 1; }
      p.material = material;
      updateCard(p);
    });
    closeModal('tpf-setup');
    renderAll();
  }

  /* ------------------------------------------------------------------ finestre */

  var modalStack = [];
  var lastFocus = {};
  // Con una finestra aperta il resto della pagina non si può usare (né con il mouse né con il tasto Tab).
  function syncInert() {
    var open = modalStack.length > 0;
    ['tpf-work', 'tpf-empty', 'tpf-bar', 'tpf-head'].forEach(function (id) {
      var el = $(id);
      if (!el) return;
      if (open) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
    modalStack.forEach(function (id, i) {
      var el = $(id);
      if (!el) return;
      if (i < modalStack.length - 1) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }
  function openModal(id) {
    var m = $(id);
    if (!m) return;
    lastFocus[id] = document.activeElement;
    m.hidden = false;
    if (modalStack.indexOf(id) < 0) modalStack.push(id);
    html.classList.add('tpf-modal-open');
    syncInert();
  }
  function closeModal(id) {
    var m = $(id);
    if (!m || m.hidden) return;
    m.hidden = true;
    m.removeAttribute('inert');
    modalStack = modalStack.filter(function (x) { return x !== id; });
    if (!modalStack.length) html.classList.remove('tpf-modal-open');
    syncInert();
    var back = lastFocus[id];
    if (back && back.focus && document.contains(back)) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
  }

  /* ------------------------------------------------------------------ modifica di una foto */

  function findPhoto(id) {
    for (var i = 0; i < S.photos.length; i++) if (S.photos[i].id === id) return S.photos[i];
    return null;
  }
  var ed = {};
  function openEditor(id) {
    var p = findPhoto(id);
    if (!p) return;
    S.editorId = id;
    ed.img.src = p.url;
    ed.ghost.src = p.url;
    openModal('tpf-editor');
    var body = document.querySelector('#tpf-editor .tpf-ed-body');
    if (body) body.scrollTop = 0;
    renderEditor();
    requestAnimationFrame(layoutStage);
    setTimeout(function () { try { $('tpf-ed-close').focus({ preventScroll: true }); } catch (e) { /* facoltativo */ } }, 30);
  }
  function closeEditor() {
    S.editorId = null;
    closeModal('tpf-editor');
    // libera la foto a piena risoluzione (memoria del telefono)
    ed.img.removeAttribute('src');
    ed.ghost.removeAttribute('src');
  }
  function editorPhoto() { return S.editorId ? findPhoto(S.editorId) : null; }

  function renderEditor() {
    keepFocus($('tpf-editor'), renderEditorNow);
  }
  function renderEditorNow() {
    var p = editorPhoto();
    if (!p) return;
    var idx = S.photos.indexOf(p);
    $('tpf-ed-title').textContent = S.photos.length > 1 ? 'Foto ' + (idx + 1) + ' di ' + S.photos.length : 'La tua foto';
    $('tpf-ed-sub').textContent = p.name;
    $('tpf-ed-prev').disabled = idx <= 0;
    $('tpf-ed-next').disabled = idx >= S.photos.length - 1;
    $('tpf-ed-size-v').textContent = sizeLabelFor(p) + (S.info[p.size] && S.info[p.size].single ? ' (foto intera)' : '');
    $('tpf-ed-material').innerHTML = segHtml(S.materials.map(function (m) { return { value: m, label: materialLabel(m), title: materialHint(m) }; }), p.material, 'data-material');
    var f = frame(p);
    var fitField = $('tpf-ed-fit-field');
    fitField.hidden = !cfg.allowWhole || f.single;
    $('tpf-ed-fit').innerHTML = segHtml(fitOptions([p]), p.fit, 'data-fit');
    ed.qty.value = p.qty;
    var locked = f.single || isWhole(p);
    ed.zoom.disabled = locked;
    ed.zoom.value = p.zoom;
    $('tpf-center').disabled = locked;
    var rot = $('tpf-rotate');
    rot.hidden = f.single;
    $('tpf-rotate-label').textContent = f.landscape ? 'Stampa in verticale' : 'Stampa in orizzontale';
    rot.disabled = f.single;
    var cut = cutShare(p);
    var hint;
    if (f.single) hint = 'In questo formato la foto si stampa tutta: il lato lungo misura ' + num(Math.max(f.W, f.H), 1) + ' cm.';
    else if (isWhole(p)) hint = 'La foto si stampa tutta, con bordi bianchi dove la sua forma è diversa dal foglio.';
    else if (cut < 0.005) hint = 'La foto riempie il foglio senza tagli.';
    else hint = 'Trascina la foto per scegliere cosa tenere: la parte chiara è quella stampata (' + num(Math.round(cut * 100)) + '% fuori dal foglio).';
    $('tpf-ed-hint').textContent = hint;
    var q = qualityOf(p);
    var qBox = $('tpf-ed-quality');
    var tip = '';
    if (q.code === 'low' || q.code === 'medium') {
      var best = bestSizeFor(p);
      if (q.code === 'low') tip = best && best !== p.size ? ' Per una stampa nitida scegli fino a ' + S.info[best].label + '.' : ' La stampa potrebbe risultare sgranata.';
      else tip = ' Va bene vista a distanza normale.';
      if (p.zoom > 1.01 && !locked) tip += ' Riducendo lo zoom aumenta la qualità.';
    }
    qBox.className = 'tpf-quality is-' + q.code;
    qBox.innerHTML = '<span class="tpf-qdot" aria-hidden="true"></span><span><strong>Qualità di stampa: ' + q.label + '</strong> · ' + q.dpi + ' dpi.' + esc(tip) + '</span>';
    var bySize = copiesBySize();
    var unit = unitPrice(p.size, p.material, bySize[p.size]);
    $('tpf-ed-price').innerHTML = unit != null ? plural(p.qty, 'copia', 'copie') + ' × ' + euro(unit) + ' = <strong>' + euro(unit * p.qty) + '</strong>' : '';
    drawStage();
  }

  function layoutStage() {
    var p = editorPhoto();
    if (!p) return;
    var stage = ed.stage;
    var sw = stage.clientWidth, sh = stage.clientHeight;
    if (!sw || !sh) return;
    var f = frame(p);
    var r = f.W / f.H;
    var pad = isWhole(p) || f.single ? 0.86 : 0.74;
    var w = sw * pad, h = w / r;
    if (h > sh * pad) { h = sh * pad; w = h * r; }
    ed.win = { w: w, h: h, x: (sw - w) / 2, y: (sh - h) / 2 };
    ed.window.style.cssText = 'left:' + ed.win.x + 'px;top:' + ed.win.y + 'px;width:' + w + 'px;height:' + h + 'px';
    drawStage();
  }
  function drawStage() {
    var p = editorPhoto();
    if (!p || !ed.win) return;
    var f = frame(p);
    var whole = isWhole(p) || f.single;
    ed.window.classList.toggle('is-whole', whole);
    ed.window.classList.toggle('is-gloss', /lucid/i.test(p.material));
    if (whole) {
      var pl = f.single ? { W: f.W, H: f.H, F: f } : placed(p);
      var iw = ed.win.w * pl.W / f.W, ih = ed.win.h * pl.H / f.H;
      ed.img.style.cssText = 'left:' + (ed.win.w - iw) / 2 + 'px;top:' + (ed.win.h - ih) / 2 + 'px;width:' + iw + 'px;height:' + ih + 'px';
      ed.ghost.style.display = 'none';
      return;
    }
    var c = crop(p);
    var sc = ed.win.w / c.sw;
    var W = p.w * sc, H = p.h * sc;
    ed.img.style.cssText = 'left:' + (-c.sx * sc) + 'px;top:' + (-c.sy * sc) + 'px;width:' + W + 'px;height:' + H + 'px';
    ed.ghost.style.cssText = 'display:block;left:' + (ed.win.x - c.sx * sc) + 'px;top:' + (ed.win.y - c.sy * sc) + 'px;width:' + W + 'px;height:' + H + 'px';
  }

  function editorChanged(p, full) {
    S.dirty = true;
    updateCard(p);
    if (full) { renderAll(); renderEditor(); requestAnimationFrame(layoutStage); }
    else { drawStage(); scheduleEditorText(); }
  }
  var textTimer = 0;
  function scheduleEditorText() {
    clearTimeout(textTimer);
    textTimer = setTimeout(function () { renderEditor(); }, 120);
  }

  function installStageGestures() {
    var pointers = {};
    var drag = null;
    function pts() { return Object.keys(pointers).map(function (k) { return pointers[k]; }); }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    function canMove(p) { var f = frame(p); return !f.single && !isWhole(p); }

    ed.stage.addEventListener('pointerdown', function (e) {
      var p = editorPhoto();
      if (!p || !canMove(p)) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { ed.stage.setPointerCapture(e.pointerId); } catch (err) { /* nessuna cattura */ }
      var list = pts();
      if (list.length === 1) drag = { x: e.clientX, y: e.clientY, c: crop(p) };
      if (list.length === 2) drag = { pinch: dist(list[0], list[1]), zoom: p.zoom };
      ed.stage.classList.add('is-dragging');
      e.preventDefault();
    });
    ed.stage.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var p = editorPhoto();
      if (!p || !drag) return;
      var list = pts();
      if (drag.pinch && list.length >= 2) {
        p.zoom = clamp(drag.zoom * dist(list[0], list[1]) / drag.pinch, 1, MAX_ZOOM);
        ed.zoom.value = p.zoom;
      } else if (!drag.pinch) {
        var c = drag.c, sc = ed.win.w / c.sw;
        var maxX = p.w - c.sw, maxY = p.h - c.sh;
        var sx = clamp(c.sx - (e.clientX - drag.x) / sc, 0, maxX);
        var sy = clamp(c.sy - (e.clientY - drag.y) / sc, 0, maxY);
        p.fx = maxX > 0.5 ? sx / maxX : 0.5;
        p.fy = maxY > 0.5 ? sy / maxY : 0.5;
      }
      editorChanged(p, false);
      e.preventDefault();
    });
    function end(e) {
      if (!pointers[e.pointerId]) return;
      delete pointers[e.pointerId];
      var p = editorPhoto();
      var list = pts();
      if (list.length === 1 && p) { var k = Object.keys(pointers)[0]; drag = { x: pointers[k].x, y: pointers[k].y, c: crop(p) }; }
      else if (!list.length) { drag = null; ed.stage.classList.remove('is-dragging'); }
    }
    ed.stage.addEventListener('pointerup', end);
    ed.stage.addEventListener('pointercancel', end);
    ed.stage.addEventListener('wheel', function (e) {
      var p = editorPhoto();
      if (!p || !canMove(p)) return;
      e.preventDefault();
      zoomAround(p, clamp(p.zoom * Math.exp(-e.deltaY * 0.0018), 1, MAX_ZOOM));
    }, { passive: false });
    ed.stage.addEventListener('keydown', function (e) {
      var p = editorPhoto();
      if (!p || !canMove(p)) return;
      var step = e.shiftKey ? 0.1 : 0.025;
      if (e.key === 'ArrowLeft') p.fx = clamp(p.fx - step, 0, 1);
      else if (e.key === 'ArrowRight') p.fx = clamp(p.fx + step, 0, 1);
      else if (e.key === 'ArrowUp') p.fy = clamp(p.fy - step, 0, 1);
      else if (e.key === 'ArrowDown') p.fy = clamp(p.fy + step, 0, 1);
      else if (e.key === '+' || e.key === '=') p.zoom = clamp(p.zoom * 1.1, 1, MAX_ZOOM);
      else if (e.key === '-') p.zoom = clamp(p.zoom / 1.1, 1, MAX_ZOOM);
      else return;
      e.preventDefault();
      ed.zoom.value = p.zoom;
      editorChanged(p, false);
    });
  }
  function zoomAround(p, z) {
    // lo zoom resta centrato su quello che si vede
    var before = crop(p);
    var cx = before.sx + before.sw / 2, cy = before.sy + before.sh / 2;
    p.zoom = z;
    var after = crop(Object.assign({}, p, { fx: 0, fy: 0 }));
    var maxX = p.w - after.sw, maxY = p.h - after.sh;
    p.fx = maxX > 0.5 ? clamp((cx - after.sw / 2) / maxX, 0, 1) : 0.5;
    p.fy = maxY > 0.5 ? clamp((cy - after.sh / 2) / maxY, 0, 1) : 0.5;
    ed.zoom.value = p.zoom;
    editorChanged(p, false);
  }

  function setupEditor() {
    ed.stage = $('tpf-stage');
    ed.window = $('tpf-window');
    ed.img = $('tpf-ed-img');
    ed.ghost = $('tpf-ghost');
    ed.zoom = $('tpf-zoom');
    ed.done = $('tpf-ed-done');
    ed.qty = $('tpf-ed-qty').querySelector('input');
    installStageGestures();
    ed.zoom.addEventListener('input', function () { var p = editorPhoto(); if (p) zoomAround(p, clamp(Number(ed.zoom.value), 1, MAX_ZOOM)); });
    ed.zoom.addEventListener('change', function () { renderEditor(); });
    $('tpf-center').addEventListener('click', function () { var p = editorPhoto(); if (!p) return; p.fx = 0.5; p.fy = 0.5; p.zoom = 1; ed.zoom.value = 1; editorChanged(p, true); });
    $('tpf-rotate').addEventListener('click', function () { var p = editorPhoto(); if (!p) return; p.swap = !p.swap; p.zoom = 1; p.fx = 0.5; p.fy = 0.5; editorChanged(p, true); });
    $('tpf-ed-size').addEventListener('click', function () { var p = editorPhoto(); if (p) openFormats({ mode: 'photo', id: p.id }); });
    $('tpf-ed-material').addEventListener('click', function (e) {
      var b = e.target.closest('[data-material]'); var p = editorPhoto();
      if (!b || !p) return;
      p.material = b.getAttribute('data-material'); editorChanged(p, true);
    });
    $('tpf-ed-fit').addEventListener('click', function (e) {
      var b = e.target.closest('[data-fit]'); var p = editorPhoto();
      if (!b || !p || b.disabled) return;
      p.fit = b.getAttribute('data-fit'); editorChanged(p, true);
    });
    $('tpf-ed-qty').addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]'); var p = editorPhoto();
      if (!b || !p) return;
      p.qty = clamp(p.qty + Number(b.getAttribute('data-step')), 1, 999);
      editorChanged(p, true);
    });
    ed.qty.addEventListener('change', function () { var p = editorPhoto(); if (!p) return; p.qty = clamp(Math.round(Number(ed.qty.value) || 1), 1, 999); editorChanged(p, true); });
    $('tpf-ed-prev').addEventListener('click', function () { stepEditor(-1); });
    $('tpf-ed-next').addEventListener('click', function () { stepEditor(1); });
    $('tpf-ed-close').addEventListener('click', closeEditor);
    ed.done.addEventListener('click', closeEditor);
    $('tpf-ed-del').addEventListener('click', function () {
      var p = editorPhoto(); if (!p) return;
      var idx = S.photos.indexOf(p);
      removePhotos([p.id]);
      if (!S.photos.length) { closeEditor(); return; }
      var next = S.photos[Math.min(idx, S.photos.length - 1)];
      openEditorKeep(next.id);
    });
    $('tpf-ed-dup').addEventListener('click', function () {
      var p = editorPhoto(); if (!p) return;
      var copy = Object.assign({}, p, { id: uid(), selected: false, upload: null, qty: 1, zoom: 1, fx: 0.5, fy: 0.5 });
      var idx = S.photos.indexOf(p);
      S.photos.splice(idx + 1, 0, copy);
      renderGrid();
      renderAll();
      openEditorKeep(copy.id);
      openFormats({ mode: 'photo', id: copy.id });
    });
    window.addEventListener('resize', function () { if (S.editorId) requestAnimationFrame(layoutStage); });
  }
  function openEditorKeep(id) {
    S.editorId = id;
    var p = findPhoto(id);
    ed.img.src = p.url;
    ed.ghost.src = p.url;
    renderEditor();
    requestAnimationFrame(layoutStage);
  }
  function stepEditor(d) {
    var p = editorPhoto(); if (!p) return;
    var idx = S.photos.indexOf(p) + d;
    if (idx < 0 || idx >= S.photos.length) return;
    openEditorKeep(S.photos[idx].id);
  }

  /* ------------------------------------------------------------------ file di stampa */

  function printKey(p) {
    var c = crop(p);
    return [p.size, p.fit, p.swap ? 1 : 0, Math.round(c.sx), Math.round(c.sy), Math.round(c.sw), Math.round(c.sh), cfg.maxDpi].join('|');
  }

  // Scrive i dpi veri nell'intestazione JFIF del JPEG (se c'è), così il laboratorio legge la misura giusta.
  async function withDpi(blob, dpi) {
    try {
      var buf = new Uint8Array(await blob.arrayBuffer());
      var d = Math.max(1, Math.min(65535, Math.round(dpi)));
      if (buf[0] === 0xFF && buf[1] === 0xD8 && buf[2] === 0xFF && buf[3] === 0xE0 &&
          buf[6] === 0x4A && buf[7] === 0x46 && buf[8] === 0x49 && buf[9] === 0x46 && buf[10] === 0) {
        buf[13] = 1;
        buf[14] = d >> 8; buf[15] = d & 255;
        buf[16] = d >> 8; buf[17] = d & 255;
        return new Blob([buf], { type: 'image/jpeg' });
      }
      if (buf[0] === 0xFF && buf[1] === 0xD8) {
        var app0 = new Uint8Array([0xFF, 0xE0, 0x00, 0x10, 0x4A, 0x46, 0x49, 0x46, 0x00, 0x01, 0x01, 0x01, d >> 8, d & 255, d >> 8, d & 255, 0x00, 0x00]);
        return new Blob([buf.subarray(0, 2), app0, buf.subarray(2)], { type: 'image/jpeg' });
      }
    } catch (e) { /* si usa il file così com'è */ }
    return blob;
  }

  async function makePrintFile(p) {
    var f = frame(p);
    var img = await loadImage(p.url);
    var cw, ch, dpi, drawArgs;
    try {
      if (isWhole(p)) {
        var pl = placed(p);
        dpi = Math.min(cfg.maxDpi, p.w / (pl.W / 2.54));
        cw = f.W / 2.54 * dpi; ch = f.H / 2.54 * dpi;
        if (cw * ch > MAX_OUTPUT_PIXELS) { var k = Math.sqrt(MAX_OUTPUT_PIXELS / (cw * ch)); dpi *= k; cw *= k; ch *= k; }
        cw = Math.max(1, Math.round(cw)); ch = Math.max(1, Math.round(ch));
        var dw = pl.W / 2.54 * dpi, dh = pl.H / 2.54 * dpi;
        drawArgs = [0, 0, p.w, p.h, (cw - dw) / 2, (ch - dh) / 2, dw, dh];
      } else {
        var c = crop(p);
        var reqW = f.W / 2.54 * cfg.maxDpi, reqH = f.H / 2.54 * cfg.maxDpi;
        var scale = Math.min(1, reqW / c.sw, reqH / c.sh);
        if (c.sw * scale * c.sh * scale > MAX_OUTPUT_PIXELS) scale = Math.sqrt(MAX_OUTPUT_PIXELS / (c.sw * c.sh));
        cw = Math.max(1, Math.round(c.sw * scale)); ch = Math.max(1, Math.round(c.sh * scale));
        dpi = cw / (f.W / 2.54);
        drawArgs = [c.sx, c.sy, c.sw, c.sh, 0, 0, cw, ch];
      }
      var canvas = document.createElement('canvas');
      canvas.width = cw; canvas.height = ch;
      var ctx = canvas.getContext('2d', { alpha: false });
      if (!ctx) throw new Error('memoria del browser esaurita');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, cw, ch);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage.apply(ctx, [img].concat(drawArgs));
      var blob = await canvasToBlob(canvas, 'image/jpeg', 0.92);
      canvas.width = canvas.height = 1;
      if (!blob || blob.size < 100) throw new Error('conversione non riuscita');
      blob = await withDpi(blob, dpi);
      var safe = String(p.name || 'foto.jpg').replace(/\.(png|jpe?g|webp|heic|heif)$/i, '') + '.jpg';
      var file;
      try { file = new File([blob], safe, { type: 'image/jpeg', lastModified: Date.now() }); } catch (e) { file = blob; file.name = safe; }
      return { file: file, width: cw, height: ch, dpi: Math.round(dpi) };
    } finally {
      img.src = '';
    }
  }

  /* ------------------------------------------------------------------ caricamento su foto.telapersonalizzata.com (come prima) */

  function fetchWithTimeout(url, opts, ms) {
    if (!window.AbortController) return fetch(url, opts);
    var ctl = new AbortController();
    var t = setTimeout(function () { ctl.abort(); }, ms);
    return fetch(url, Object.assign({}, opts, { signal: ctl.signal })).finally(function () { clearTimeout(t); });
  }

  async function uploadPrint(p, printFile) {
    var file = printFile.file;
    var name = file.name, type = file.type || 'image/jpeg';
    var storageUrl = UPLOAD_BASE + '/storage.php?shop=' + encodeURIComponent(UPLOAD_SHOP) + '&name=' + encodeURIComponent(name) +
      '&type=' + encodeURIComponent(type) + '&public=1&cb=' + rndNumber(18);
    var r = await fetchWithTimeout(storageUrl, {}, 30000);
    if (!r.ok) throw new Error('preparazione del caricamento non riuscita');
    var storage = await r.json();
    if (!storage || !storage.upload || !storage.download || !storage.path) throw new Error('risposta del server foto non valida');
    var put = await fetchWithTimeout(storage.upload, { method: 'PUT', body: file }, 240000);
    if (!put.ok) throw new Error('invio del file non riuscito');
    var payload = {
      name: name,
      size: file.size,
      mimeType: type,
      meta: {
        variant: 'original',
        productId: Number(cfg.productId),
        productHandle: 'stampa-foto',
        productTitle: 'Stampa foto',
        contentLength: file.size,
        uploadLift: Number(cfg.productId),
        uploadField: 0
      },
      url: storage.download,
      path: storage.path
    };
    var reg = await fetchWithTimeout(UPLOAD_BASE + '/upload.php?shop=' + UPLOAD_SHOP + '&config=' + UPLOAD_CONFIG + '&token=' + uid(), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    }, 30000);
    if (!reg.ok) throw new Error('registrazione del file non riuscita');
    var data = await reg.json();
    if (!data || !data.url) throw new Error('indirizzo del file mancante');
    return data.url;
  }

  async function preparePhoto(p) {
    var key = printKey(p);
    if (p.upload && p.upload.key === key && p.upload.url) return p.upload.url;
    var last;
    for (var attempt = 1; attempt <= 3; attempt++) {
      try {
        var pf = await makePrintFile(p);
        var url = await uploadPrint(p, pf);
        p.upload = { key: key, url: url, dpi: pf.dpi, width: pf.width, height: pf.height };
        return url;
      } catch (err) {
        last = err;
        if (attempt < 3) await sleep(1200 * attempt);
      }
    }
    throw last || new Error('caricamento non riuscito');
  }

  // Più foto insieme; sul telefono al massimo due e le foto grandi (oltre 12 MP) una alla volta.
  async function runUploads(list, onProgress) {
    var cap = IS_MOBILE ? 2 : 4;
    var next = 0, done = 0, failed = [];
    var bigLock = Promise.resolve();
    async function worker() {
      while (next < list.length) {
        var p = list[next++];
        var big = p.w * p.h > 12e6;
        var release;
        if (IS_MOBILE && big) {
          var prev = bigLock;
          bigLock = new Promise(function (r) { release = r; });
          await prev;
        }
        try { await preparePhoto(p); }
        catch (err) { failed.push({ p: p, err: err }); }
        finally { if (release) release(); }
        done++;
        onProgress(done, list.length);
      }
    }
    var workers = [];
    for (var i = 0; i < Math.min(cap, list.length); i++) workers.push(worker());
    await Promise.all(workers);
    return failed;
  }

  /* ------------------------------------------------------------------ carrello (stesse righe e proprietà di prima) */

  function buildCartItems() {
    var t = totals();
    var groups = {};
    var order = [];
    S.photos.forEach(function (p) {
      if (!p.upload || !p.upload.url || p.upload.key !== printKey(p)) {
        throw new Error('una foto è cambiata durante il caricamento');
      }
      var tier = tierFor(t.bySize[p.size]).key;
      var v = variantFor(p.size, p.material, tier);
      if (!v) throw new Error('variante non trovata: ' + p.size + ' / ' + p.material + ' / ' + tier);
      if (!groups[v.id]) { groups[v.id] = { variant: v, tier: tier, copies: [] }; order.push(v.id); }
      for (var i = 0; i < p.qty; i++) groups[v.id].copies.push(p.upload.url);
    });
    var items = [];
    order.forEach(function (vid) {
      var g = groups[vid];
      var parts = Math.ceil(g.copies.length / CART_PHOTOS_PER_LINE);
      var batch = 'FOTO-' + Date.now() + '-' + rndNumber(6);
      S.batches.push(batch);
      for (var start = 0, part = 1; start < g.copies.length; start += CART_PHOTOS_PER_LINE, part++) {
        var chunk = g.copies.slice(start, start + CART_PHOTOS_PER_LINE);
        var props = {
          _lotto_foto: batch,
          _parte: part + '/' + parts,
          _totale_formato: String(g.copies.length),
          _formato: g.variant.option1,
          _materiale: g.variant.option2,
          _fascia: g.tier
        };
        chunk.forEach(function (u, i) { props['_photo' + (i + 1)] = u; });
        items.push({ id: g.variant.id, quantity: chunk.length, properties: props });
      }
    });
    return items;
  }

  async function addItem(item) {
    var last;
    var body = { items: [{ id: item.id, quantity: item.quantity, properties: item.properties }] };
    for (var attempt = 1; attempt <= 3; attempt++) {
      try {
        var r = await fetchWithTimeout((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin'
        }, 30000);
        var data = null;
        try { data = await r.json(); } catch (e) { data = null; }
        if (!r.ok) throw new Error((data && (data.description || data.message)) || ('errore ' + r.status));
        return data;
      } catch (err) {
        last = err;
        if (attempt < 3) await sleep(1500 * attempt);
      }
    }
    throw last;
  }

  // Toglie dal carrello le righe create prima da questa pagina (ritorno dal carrello o nuovo tentativo).
  async function removePreviousLines() {
    if (!S.batches.length) return 0;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var r = await fetchWithTimeout(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }, 20000);
    if (!r.ok) throw new Error('carrello non leggibile');
    var cart = await r.json();
    var mine = (cart.items || []).filter(function (it) {
      return it.properties && S.batches.indexOf(it.properties._lotto_foto) >= 0;
    });
    for (var i = 0; i < mine.length; i++) {
      var ch = await fetchWithTimeout(base + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ id: mine[i].key, quantity: 0 })
      }, 20000);
      if (!ch.ok) throw new Error('righe precedenti non aggiornate');
    }
    return mine.length;
  }

  /* ---- invio */

  function sendUi(state, text, pct) {
    $('tpf-send-text').textContent = text || '';
    $('tpf-send-bar').style.width = (pct == null ? 0 : pct) + '%';
    var failed = state === 'error';
    $('tpf-send-actions').hidden = !failed;
    $('tpf-send-note').hidden = failed;
    $('tpf-send-spinner').hidden = failed;
    $('tpf-send-title').textContent = failed ? 'Non siamo riusciti a finire' : (state === 'cart' ? 'Aggiungiamo al carrello' : 'Prepariamo le tue stampe');
  }

  function lowResPhotos() { return S.photos.filter(function (p) { return qualityOf(p).code === 'low'; }); }

  function startCheckout() {
    if (S.busy || !S.photos.length || S.reading.active) return;
    var low = lowResPhotos();
    if (low.length) {
      $('tpf-lowres-text').textContent = (low.length === 1 ? 'Una foto ha' : low.length + ' foto hanno') +
        ' pochi pixel per il formato scelto: stampata potrebbe risultare sgranata. Puoi scegliere un formato più piccolo o stampare comunque.';
      $('tpf-lowres-thumbs').innerHTML = low.slice(0, 8).map(function (p) {
        return '<figure><span class="tpf-paper" style="' + paperStyle(p) + '"><img src="' + esc(p.thumb) + '" alt="" style="' + imgStyle(p) + '"></span><figcaption>' + esc(sizeLabelFor(p)) + ' · ' + qualityOf(p).dpi + ' dpi</figcaption></figure>';
      }).join('') + (low.length > 8 ? '<p class="tpf-muted">e altre ' + (low.length - 8) + '</p>' : '');
      openModal('tpf-lowres');
      $('tpf-lowres-review').focus();
      return;
    }
    checkout();
  }

  async function checkout() {
    if (S.busy) return;
    S.busy = true;
    renderSummary();
    openModal('tpf-send');
    var list = S.photos.slice();
    try {
      sendUi('upload', 'Preparo e carico le foto: 0 di ' + list.length, 2);
      var failed = await runUploads(list, function (d, n) {
        sendUi('upload', 'Preparo e carico le foto: ' + d + ' di ' + n, Math.round(d / n * 90));
      });
      if (failed.length) {
        var e = new Error((failed.length === 1 ? 'Una foto non è stata caricata' : failed.length + ' foto non sono state caricate') +
          ' (' + (failed[0].err && failed[0].err.message ? failed[0].err.message : 'errore di rete') + '). Le altre sono pronte: controlla la connessione e premi Riprova.');
        e.soft = true;
        throw e;
      }
      if (S.batches.length) {
        sendUi('cart', 'Aggiorno le stampe già nel carrello…', 91);
        await removePreviousLines();
      }
      var items = buildCartItems();
      sendUi('cart', 'Aggiungo al carrello…', 92);
      for (var i = 0; i < items.length; i++) {
        await addItem(items[i]);
        sendUi('cart', 'Aggiungo al carrello: ' + (i + 1) + ' di ' + items.length, 92 + Math.round((i + 1) / items.length * 8));
      }
      await saveDeliveryPreference();
      S.dirty = false;
      S.inCart = true;
      sendUi('cart', 'Fatto! Apro il carrello…', 100);
      try { document.dispatchEvent(new CustomEvent('tp:foto:added', { detail: { photos: list.length, copies: totals().copies } })); } catch (err) { /* facoltativo */ }
      window.location.assign(cfg.cartUrl || '/cart');
    } catch (err) {
      S.busy = false;
      sendUi('error', err && err.message ? (err.soft ? err.message : 'Operazione interrotta: ' + err.message + '. Le foto restano qui: premi Riprova (le righe già entrate nel carrello vengono sostituite, non duplicate).') : 'Errore sconosciuto. Riprova.');
      renderSummary();
    }
  }

  /* ------------------------------------------------------------------ passaggio delle foto da altre pagine (IndexedDB, come prima) */

  function openDb() {
    return new Promise(function (resolve, reject) {
      if (!window.indexedDB) { reject(new Error('no-idb')); return; }
      var req = indexedDB.open(DB_NAME, 1);
      req.onupgradeneeded = function () { if (!req.result.objectStoreNames.contains(DB_STORE)) req.result.createObjectStore(DB_STORE, { keyPath: 'id' }); };
      req.onsuccess = function () { resolve(req.result); };
      req.onerror = function () { reject(req.error || new Error('idb')); };
    });
  }
  function idb(mode, fn) {
    return openDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(DB_STORE, mode);
        var req = fn(tx.objectStore(DB_STORE));
        var result;
        if (req) req.onsuccess = function () { result = req.result; };
        tx.oncomplete = function () { db.close(); resolve(result); };
        tx.onerror = tx.onabort = function () { db.close(); reject(tx.error || new Error('idb-tx')); };
      });
    });
  }
  function sweepHandoffs() {
    return openDb().then(function (db) {
      return new Promise(function (resolve) {
        var tx = db.transaction(DB_STORE, 'readwrite');
        var req = tx.objectStore(DB_STORE).openCursor();
        req.onsuccess = function () {
          var cur = req.result;
          if (!cur) return;
          var at = Number(cur.value && cur.value.createdAt);
          if (Number.isFinite(at) && Date.now() - at > HANDOFF_KEEP) cur.delete();
          cur.continue();
        };
        tx.oncomplete = tx.onerror = tx.onabort = function () { db.close(); resolve(); };
      });
    }).catch(function () {});
  }
  var handoffId = null;
  function releaseHandoff() {
    if (!handoffId) return;
    var id = handoffId;
    handoffId = null;
    idb('readwrite', function (s) { return s.delete(id); }).catch(function () {});
  }
  function handoffErrorMessage() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('tp_foto_err')) return;
    url.searchParams.delete('tp_foto_err');
    try { history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (e) { /* facoltativo */ }
    els.emptyStatus.textContent = 'Le foto scelte erano troppe o troppo pesanti per passarle da una pagina all\'altra. Sceglile qui: da questa pagina non ci sono limiti.';
  }
  async function consumeHandoff() {
    var url = new URL(window.location.href);
    var id = url.searchParams.get('tp_handoff');
    if (!id) return false;
    url.searchParams.delete('tp_handoff');
    try { history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (e) { /* facoltativo */ }
    try {
      var rec = await idb('readonly', function (s) { return s.get(id); });
      if (!rec || !Array.isArray(rec.files) || !rec.files.length || Date.now() - rec.createdAt > HANDOFF_MAX_AGE) throw new Error('handoff');
      if (rec.product && rec.product.id && Number(rec.product.id) !== Number(cfg.productId)) throw new Error('handoff-product');
      var files = rec.files.map(function (it) {
        try { return new File([it.blob], it.name, { type: it.type, lastModified: it.lastModified || Date.now() }); }
        catch (e) { var b = it.blob; b.name = it.name; return b; }
      });
      // Non si cancella adesso: in Safari i file letti da IndexedDB smettono di aprirsi appena il record sparisce
      // (servono di nuovo anche per il file di stampa). Si cancella alla chiusura della pagina (pagehide).
      handoffId = id;
      await addFiles(files, { size: rec.format || null });
      if (Number(rec.skipped) > 0) {
        showNotice('Hai scelto ' + (files.length + Number(rec.skipped)) + ' foto: ne abbiamo prese ' + files.length + '. Aggiungi le altre con «Aggiungi foto».', 'info');
      }
      return true;
    } catch (err) {
      els.emptyStatus.textContent = 'Non è stato possibile recuperare le foto scelte. Selezionale di nuovo qui sotto.';
      return false;
    }
  }

  /* ------------------------------------------------------------------ Ilaria dalla testata */

  function setupHelp() {
    var help = $('tpf-help');
    if (!help) return;
    var chat = document.getElementById('tp-ilaria-root');
    var opened = false;
    function sync() {
      var trigger = chat && chat.querySelector('.tp-il-prelaunch');
      help.hidden = !(chat && !chat.hidden && ((trigger && !trigger.hidden) || opened));
    }
    help.addEventListener('click', function () {
      if (!chat) return;
      var trigger = chat.querySelector('.tp-il-prelaunch');
      var target = (trigger && !trigger.disabled && trigger) || chat.querySelector('button:not(.tp-il-prelaunch)') || trigger;
      opened = true;
      if (target) target.click();
    });
    sync();
    if (chat && window.MutationObserver) new MutationObserver(sync).observe(chat, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
  }

  /* ------------------------------------------------------------------ eventi */

  function pickFiles() {
    var input = els.file;
    input.value = '';
    input.click();
  }

  function bindEvents() {
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-tpf-pick]')) { e.preventDefault(); pickFiles(); }
      if (e.target.closest('[data-tpf-undo]')) { e.preventDefault(); undoRemove(); }
    });
    els.file.addEventListener('change', function () {
      var files = Array.prototype.slice.call(els.file.files || []);
      if (files.length) addFiles(files);
      els.file.value = '';
    });

    // trascinamento su tutta la pagina
    var depth = 0;
    function hasFiles(e) { return e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types || [], 'Files') >= 0; }
    document.addEventListener('dragenter', function (e) { if (!hasFiles(e) || S.busy || modalStack.length) return; depth++; els.dropveil.hidden = false; e.preventDefault(); });
    document.addEventListener('dragover', function (e) { if (!hasFiles(e)) return; e.preventDefault(); });
    document.addEventListener('dragleave', function (e) { if (!hasFiles(e)) return; depth = Math.max(0, depth - 1); if (!depth) els.dropveil.hidden = true; });
    document.addEventListener('drop', function (e) {
      if (!hasFiles(e)) return;
      e.preventDefault(); depth = 0; els.dropveil.hidden = true;
      if (S.busy || modalStack.length) return;
      addFiles(e.dataTransfer.files);
    });

    // griglia
    els.grid.addEventListener('click', function (e) {
      var li = e.target.closest('.tpf-card');
      if (!li) return;
      var p = findPhoto(li.dataset.id);
      var actEl = e.target.closest('[data-act]');
      if (!p || !actEl) return;
      var act = actEl.getAttribute('data-act');
      if (act === 'edit') openEditor(p.id);
      else if (act === 'delete') removePhotos([p.id]);
      else if (act === 'plus' || act === 'minus') {
        p.qty = clamp(p.qty + (act === 'plus' ? 1 : -1), 1, 999);
        var input = li.querySelector('[data-act="qty"]');
        if (input) input.value = p.qty;
        S.dirty = true;
        renderSummary();
      }
    });
    els.grid.addEventListener('change', function (e) {
      var li = e.target.closest('.tpf-card');
      if (!li) return;
      var p = findPhoto(li.dataset.id);
      if (!p) return;
      var act = e.target.getAttribute('data-act');
      if (act === 'select') {
        p.selected = e.target.checked;
        li.classList.toggle('is-selected', p.selected);
        renderToolbar();
      } else if (act === 'qty') {
        p.qty = clamp(Math.round(Number(e.target.value) || 1), 1, 999);
        e.target.value = p.qty;
        S.dirty = true;
        renderSummary();
      }
    });

    // barra per tutte
    els.bulkSize.addEventListener('click', function () { openFormats({ mode: 'bulk' }); });
    els.bulkMaterial.addEventListener('click', function (e) {
      var b = e.target.closest('[data-material]');
      if (!b) return;
      applyToScope({ material: b.getAttribute('data-material') });
      S.defaults.material = b.getAttribute('data-material');
    });
    els.bulkFit.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fit]');
      if (!b || b.disabled) return;
      applyToScope({ fit: b.getAttribute('data-fit') });
      S.defaults.fit = b.getAttribute('data-fit');
    });
    els.selectAll.addEventListener('click', function () { S.photos.forEach(function (p) { p.selected = true; }); renderGrid(); renderToolbar(); });
    els.selectNone.addEventListener('click', function () { S.photos.forEach(function (p) { p.selected = false; }); renderGrid(); renderToolbar(); });
    els.removeSelected.addEventListener('click', function () {
      var ids = S.photos.filter(function (p) { return p.selected; }).map(function (p) { return p.id; });
      if (ids.length) removePhotos(ids);
    });

    // misura e carta dopo la scelta delle foto
    $('tpf-setup-sizes').addEventListener('click', function (e) {
      var b = e.target.closest('[data-size]');
      if (!b || !S.setup) return;
      S.setup.size = b.getAttribute('data-size');
      renderSetup();
    });
    $('tpf-setup-papers').addEventListener('click', function (e) {
      var b = e.target.closest('[data-material]');
      if (!b || !S.setup) return;
      S.setup.material = b.getAttribute('data-material');
      renderSetup();
    });
    $('tpf-setup-go').addEventListener('click', closeSetup);

    // formati
    $('tpf-formats-list').addEventListener('click', function (e) {
      var b = e.target.closest('[data-size]');
      if (b) chooseFormat(b.getAttribute('data-size'));
    });

    // chiusura finestre
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-tpf-close]');
      if (c) { closeModal(c.closest('.tpf-modal').id); return; }
      if (e.target.classList && e.target.classList.contains('tpf-modal') && e.target.id !== 'tpf-send') {
        if (e.target.id === 'tpf-editor') closeEditor();
        else if (e.target.id === 'tpf-setup') closeSetup();
        else closeModal(e.target.id);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !modalStack.length) return;
      var top = modalStack[modalStack.length - 1];
      if (top === 'tpf-send') return;
      e.preventDefault();
      if (top === 'tpf-editor') closeEditor();
      else if (top === 'tpf-setup') closeSetup();
      else closeModal(top);
    });

    // consegna: a casa / ritiro in studio (frecce come un gruppo di opzioni)
    els.delivery.addEventListener('click', function (e) {
      var b = e.target.closest('[data-delivery]');
      if (b) setDelivery(b.getAttribute('data-delivery'));
    });
    els.delivery.addEventListener('keydown', function (e) {
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
      e.preventDefault();
      setDelivery(S.delivery === 'home' ? 'pickup' : 'home');
      var cur = els.delivery.querySelector('[aria-checked="true"]');
      if (cur) cur.focus();
    });

    // carrello
    els.cta.addEventListener('click', startCheckout);
    els.barCta.addEventListener('click', startCheckout);
    $('tpf-bar-sum').addEventListener('click', function () {
      var s = $('tpf-summary');
      if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    $('tpf-lowres-go').addEventListener('click', function () { closeModal('tpf-lowres'); if (!S.reading.active) checkout(); });
    $('tpf-lowres-review').addEventListener('click', function () {
      closeModal('tpf-lowres');
      var low = lowResPhotos();
      S.photos.forEach(function (p) { p.selected = low.indexOf(p) >= 0; });
      renderGrid(); renderToolbar();
      if (low[0]) { var li = $('tpf-card-' + low[0].id); if (li) li.scrollIntoView({ block: 'center' }); }
      showNotice('Le foto con pochi pixel sono selezionate: scegli per loro un formato più piccolo con «Formato».', 'info');
    });
    $('tpf-send-close').addEventListener('click', function () { closeModal('tpf-send'); });
    $('tpf-send-retry').addEventListener('click', function () { checkout(); });

    // indietro dalla testata compatta: pagina precedente del sito, altrimenti la home
    var back = $('tpf-back');
    if (back) back.addEventListener('click', function (e) {
      try {
        if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) { e.preventDefault(); history.back(); }
      } catch (err) { /* link normale */ }
    });

    // ritorno con il tasto indietro dal carrello (pagina conservata dal browser)
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !S.busy) return;
      S.busy = false;
      closeModal('tpf-send');
      renderSummary();
      showNotice('Queste stampe sono già nel carrello. Se aggiungi foto o cambi qualcosa, premi «Aggiorna il carrello»: le sostituiamo, senza doppioni.', 'info');
    });

    // pagina chiusa davvero (non messa da parte per il tasto indietro): le foto passate dalla home non servono più
    window.addEventListener('pagehide', function (e) {
      if (!e.persisted) releaseHandoff();
    });

    window.addEventListener('beforeunload', function (e) {
      if (!S.dirty || !S.photos.length || S.busy) return;
      e.preventDefault();
      e.returnValue = '';
    });
  }

  /* ------------------------------------------------------------------ avvio */

  function start() {
    cacheEls();
    try { if (sessionStorage.getItem('tpf-delivery') === 'pickup') S.delivery = 'pickup'; } catch (e) { /* facoltativo */ }
    setupEditor();
    bindEvents();
    setupHelp();
    S.productReady = loadProduct().then(function () {
      renderPricelist();
      renderAll();
    }).catch(function (err) {
      console.error('tp-foto-v8: prodotto non caricato', err);
      els.emptyStatus.textContent = 'Non riusciamo a caricare formati e prezzi. Ricarica la pagina tra poco.';
    });
    handoffErrorMessage();
    sweepHandoffs().then(consumeHandoff);
    // per le prove automatiche e l'assistenza: stato leggibile, niente contenuto delle foto
    window.tpFotoV8 = {
      version: cfg.version || '8.0.0',
      state: S,
      frame: frame, crop: crop, quality: qualityOf, totals: totals, buildCartItems: buildCartItems, makePrintFile: makePrintFile,
      addFiles: addFiles,
      removePhotos: removePhotos
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();